import { createClient } from '@supabase/supabase-js'

// 请将这些值替换为你的Supabase项目配置
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'YOUR_SUPABASE_URL'
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'YOUR_SUPABASE_ANON_KEY'

// 检查环境变量是否正确设置
if (supabaseUrl === 'YOUR_SUPABASE_URL' || supabaseAnonKey === 'YOUR_SUPABASE_ANON_KEY') {
  console.error('请先配置 Supabase 环境变量！')
  console.error('创建 .env 文件并添加以下内容：')
  console.error('REACT_APP_SUPABASE_URL=你的_supabase_url')
  console.error('REACT_APP_SUPABASE_ANON_KEY=你的_supabase_anon_key')
}

export const supabase = supabaseUrl !== 'YOUR_SUPABASE_URL' && supabaseAnonKey !== 'YOUR_SUPABASE_ANON_KEY' 
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null

// 数据库表结构建议：
/*
-- 房间表
CREATE TABLE rooms (
  id UUID DEFAULT gen_random_uuid() PRIMARY KEY,
  room_key VARCHAR(50) UNIQUE NOT NULL,
  room_name VARCHAR(100) NOT NULL,
  max_players INTEGER DEFAULT 6,
  current_players INTEGER DEFAULT 0,
  status VARCHAR(20) DEFAULT 'waiting', -- waiting, playing, finished
  host_id UUID,
  created_at TIMESTAMP WITH TIME ZONE DEFAULT NOW(),
  updated_at TIMESTAMP WITH TIME ZONE DEFAULT NOW()
);

-- 玩家表
CREATE TABLE players (
  id UUID DEFAULT gen_random_uuid() PRIMARY KEY,
  room_id UUID REFERENCES rooms(id) ON DELETE CASCADE,
  player_name VARCHAR(50) NOT NULL,
  chips INTEGER DEFAULT 1000,
  seat_position INTEGER,
  is_host BOOLEAN DEFAULT FALSE,
  is_active BOOLEAN DEFAULT TRUE,
  last_action VARCHAR(20), -- fold, call, raise, check, all_in
  joined_at TIMESTAMP WITH TIME ZONE DEFAULT NOW(),
  updated_at TIMESTAMP WITH TIME ZONE DEFAULT NOW()
);

-- 游戏记录表
CREATE TABLE game_sessions (
  id UUID DEFAULT gen_random_uuid() PRIMARY KEY,
  room_id UUID REFERENCES rooms(id) ON DELETE CASCADE,
  session_number INTEGER DEFAULT 1,
  pot_amount INTEGER DEFAULT 0,
  current_bet INTEGER DEFAULT 0,
  current_player_id UUID REFERENCES players(id),
  game_stage VARCHAR(20) DEFAULT 'preflop', -- preflop, flop, turn, river, showdown
  community_cards TEXT[], -- 存储公共牌
  status VARCHAR(20) DEFAULT 'active', -- active, finished
  winner_id UUID REFERENCES players(id),
  created_at TIMESTAMP WITH TIME ZONE DEFAULT NOW(),
  updated_at TIMESTAMP WITH TIME ZONE DEFAULT NOW()
);

-- 行动记录表
CREATE TABLE game_actions (
  id UUID DEFAULT gen_random_uuid() PRIMARY KEY,
  game_session_id UUID REFERENCES game_sessions(id) ON DELETE CASCADE,
  player_id UUID REFERENCES players(id),
  action_type VARCHAR(20) NOT NULL, -- fold, call, raise, check, all_in
  bet_amount INTEGER DEFAULT 0,
  chips_after INTEGER,
  created_at TIMESTAMP WITH TIME ZONE DEFAULT NOW()
);

-- 启用实时更新
ALTER TABLE rooms ENABLE ROW LEVEL SECURITY;
ALTER TABLE players ENABLE ROW LEVEL SECURITY;
ALTER TABLE game_sessions ENABLE ROW LEVEL SECURITY;
ALTER TABLE game_actions ENABLE ROW LEVEL SECURITY;

-- 创建简单的策略（因为是内部使用，所以比较宽松）
CREATE POLICY "Enable all for rooms" ON rooms FOR ALL USING (true);
CREATE POLICY "Enable all for players" ON players FOR ALL USING (true);
CREATE POLICY "Enable all for game_sessions" ON game_sessions FOR ALL USING (true);
CREATE POLICY "Enable all for game_actions" ON game_actions FOR ALL USING (true);
*/ 